import { render, staticRenderFns } from "./ResetPasswordPage.vue?vue&type=template&id=0c00970c&scoped=true&"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordPage.vue?vue&type=style&index=0&id=0c00970c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c00970c",
  null
  
)

export default component.exports